import { CSSProperties } from 'react';

/** Shared AG Grid style for the explainer tables; theme-aware border + flat (no hover/range) read-only look. */
export function getExplainerGridStyle(isDark: boolean): CSSProperties {
  return {
    height: '100%',
    width: '100%',
    '--ag-border-color': isDark ? '#252B32' : '#e0e0e0',
    '--ag-cell-horizontal-border': '1px solid var(--ag-border-color)',
    '--ag-row-hover-color': 'transparent',
    '--ag-selected-row-background-color': 'transparent',
    '--ag-range-selection-background-color': 'transparent',
    '--ag-range-selection-background-color-2': 'transparent',
    '--ag-range-selection-background-color-3': 'transparent',
    '--ag-range-selection-background-color-4': 'transparent',
    '--ag-range-selection-border-color': isDark ? '#252B32' : 'gray',
  } as CSSProperties;
}
